import { defHttp } from "/@/utils/http/axios";
import {
  LoginParams,
  RegisterParams,
  UserPageResultModel,
  UserPageParams,
  ChangePassParams,
  ChangeUserPassParams,
  LoginResultModel,
  UserWebIdsModel,
} from "./model/userModel";
import { ErrorMessageMode } from "types/axios";
import { Domain } from "../domain";
import { NoDataResponse } from "./model/common";
// 登录
export function loginApi(data: LoginParams, mode: ErrorMessageMode = "modal") {
  return defHttp.post<LoginResultModel>(
    {
      url: `${Domain}/api/login`,
      data,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
    },
    {
      errorMessageMode: mode,
    }
  );
}
// 修改密码
export function changePass(
  data: ChangePassParams,
  mode: ErrorMessageMode = "modal"
) {
  return defHttp.post<LoginResultModel>(
    {
      url: `${Domain}/api/user/changePass`,
      data,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
    },
    {
      errorMessageMode: mode,
    }
  );
}

// 修改用户密码
export function changeUserPass(
  data: ChangeUserPassParams,
  mode: ErrorMessageMode = "modal"
) {
  return defHttp.post<LoginResultModel>(
    {
      url: `${Domain}/api/user/changeUserPass`,
      data,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
    },
    {
      errorMessageMode: mode,
    }
  );
}

// 获取用户列表
export function getUserListPage(
  params: UserPageParams,
  mode: ErrorMessageMode = "modal"
) {
  return defHttp.get<UserPageResultModel>(
    {
      url: `${Domain}/api/user/list`,
      params,
    },
    {
      errorMessageMode: mode,
    }
  );
}
export function RegisterApi(
  data: RegisterParams,
  mode: ErrorMessageMode = "modal"
) {
  return defHttp.post<NoDataResponse>(
    {
      url: `${Domain}/api/user/createUser`,
      data,
    },
    {
      errorMessageMode: mode,
    }
  );
}

// 获取用户信息 TODO: 暂无接口
export function getUserInfo(mode: ErrorMessageMode = "modal") {
  return defHttp.get<unknown>(
    {
      url: `${Domain}/sys/user/info`,
    },
    {
      errorMessageMode: mode,
    }
  );
}

// 修改用户站点权限
export function changeUserWeb(
  id: string,
  web_ids: number[],
  is_check: 0 | 1,
  mode: ErrorMessageMode = "modal"
) {
  return defHttp.get<NoDataResponse>(
    {
      url: `${Domain}/api/user/changeUserWeb`,
      params: {
        id,
        web_ids,
        is_check,
      },
    },
    {
      errorMessageMode: mode,
    }
  );
}

// 退出登录
export function logout(mode: ErrorMessageMode = "modal") {
  return defHttp.get<NoDataResponse>(
    {
      url: `${Domain}/login/logout`,
    },
    {
      errorMessageMode: mode,
    }
  );
}

// /** 分页获取用户 */
export function userPage(
  params: UserPageParams,
  mode: ErrorMessageMode = "modal"
) {
  return defHttp.get<UserPageResultModel>(
    {
      url: `${Domain}/api/user/list`,
      params,
    },
    {
      errorMessageMode: mode,
    }
  );
}

// 获取用户站点权限
export function getUserWeb(id: string, mode: ErrorMessageMode = "modal") {
  return defHttp.get<UserWebIdsModel>(
    {
      url: `${Domain}/api/user/getUserWeb`,
      params: {
        id,
      },
    },
    {
      errorMessageMode: mode,
    }
  );
}
